<div style="position: relative;" class="mb-3" [style.height]="height + 20 + 'px'">
  <mat-label *ngIf="!label_block && !hide_label" class="label req text-nowrap html-textarea-label"
    [title]="label ? (label | HTMLFormatter : 1) : ''" [ngClass]="{'req':required}"
    [innerHtml]="label| HTMLFormatter : 1">
  </mat-label>
  <i class="fa fa-refresh float-right" (click)="clearSign()" matTooltip="Clear" *ngIf="!disabled"></i>
  <div #canvas_container [style.width]="width" [style.height]="height + 'px'" class="canvas-container mt-1 mx-1"
    id="drop-zone" (dragover)="active=1;" (dragleave)="active=0;" (drop)="active=0;"
    [attr.data-present]="form_group.get([this.form_control]) && form_group.get([this.form_control]).value && form_group.get([this.form_control]).value.length ? 'yes' : 'no'"
    (click)="!disabled ? fileInput.click():''" [attr.disable-drop]="!disabled ?'poniter' : ''">
    <img class="w-100 h-100 image"
      *ngIf="form_group.get([this.form_control]) && form_group.get([this.form_control]).value && form_group.get([this.form_control]).value.length;else placeholderText"
      [src]="storage_url+form_group.get([this.form_control]).value[0].cdnPath" alt="" srcset="">
  </div>
  <!-- <span class="d-block text-center hint pointer mx-auto w-100" *ngIf="!disabled" (click)="fileInput.click()">
    {{placeholder}}
  </span> -->


</div>
<ng-template #placeholderText>
  <div class="hint">
    {{placeholder}}
  </div>
</ng-template>

<input #fileInput [accept]="supported_files" [readonly]="disabled" [disabled]="disabled? true :false"
  (change)="fileInputChanged($event.target.files)" id="input-file{{id}}" type="file" style="display:none;"
  [accept]="'image/*'">